import { IS_USE_PRODUCTION_ENV } from '@/constants/is-use-production-env';

const StoreConfig = {
  category_url_suffix: '/',
  store_code: process.env.NEXT_PUBLIC_STORE_VIEW_CODE,
  configurable_thumbnail_source: 'itself',
  product_url_suffix: '.html',
  available_countries: [
    {
      code: 'us',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/us.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/us-mobile.png`,
      name: 'United States',
      urlPart: IS_USE_PRODUCTION_ENV ? 'awbridal.com' : '192.168.11.99:30000',
      currency: 'USD',
      language: 'English',
      hreflang: 'en-us',
      basePath: '',
      url: IS_USE_PRODUCTION_ENV ? 'https://www.awbridal.com' : 'http://192.168.11.99:30000',
    },
    {
      code: 'uk',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/gb.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/gb-mobile.png`,
      name: 'United Kingdom',
      urlPart: IS_USE_PRODUCTION_ENV ? 'awbridal.co.uk' : '192.168.11.99:4000',
      currency: 'GBP',
      language: 'English',
      hreflang: 'en-gb',
      basePath: '',
      url: IS_USE_PRODUCTION_ENV ? 'https://www.awbridal.co.uk' : 'http://192.168.11.99:4000',
    },
    {
      code: 'ca',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/ca.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/ca-mobile.png`,
      name: 'Canada',
      urlPart: IS_USE_PRODUCTION_ENV ? 'awbridal.ca' : '192.168.11.99:5000',
      currency: 'CAD',
      language: 'English',
      hreflang: 'en-ca',
      basePath: '',
      url: IS_USE_PRODUCTION_ENV ? 'https://www.awbridal.ca' : 'http://192.168.11.99:5000',
    },
    {
      code: 'au',
      icon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/au.png`,
      mobileIcon: `${process.env.NEXT_PUBLIC_BASE_PATH}/icons/au-mobile.png`,
      name: 'Australia',
      urlPart: IS_USE_PRODUCTION_ENV ? 'awbridal.com/au' : '192.168.11.99:8000/au',
      currency: 'AUD',
      language: 'English',
      hreflang: 'en-au',
      basePath: '/au',
      url: IS_USE_PRODUCTION_ENV ? 'https://www.awbridal.com/au' : 'http://192.168.11.99:8000/au',
    },
    {
      code: 'sg',
      icon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/sg.png',
      mobileIcon: process.env.NEXT_PUBLIC_BASE_PATH + '/icons/sg-mobile.png',
      name: 'Singapore',
      urlPart: IS_USE_PRODUCTION_ENV ? `awbridal.com/sg` : '192.168.11.99:11000/sg',
      currency: 'SGD',
      language: 'English',
      hreflang: 'en-sg',
      basePath: '/sg',
      url: IS_USE_PRODUCTION_ENV ? `https://www.awbridal.com/sg` : 'http://192.168.11.99:11000/sg',
    },
  ],
  // 注:available_countries 与 Magento store 表里 is_active=1 的站点严格一致
  // (us / uk / ca / au / sg)。IE / NZ / DE_EN 虽然有 pm2 进程和 env 文件,
  // 但 store 表里 is_active=0,是已下线站点,生产实测其路径全部 302 到美国站。
  // 【不要】把它们加进来 —— hreflang 必须指向可索引的规范 URL,
  // 指向已关停站点会被 Google 忽略甚至判为配置错误。

  // 修改地址时使用
  default_country_code: process.env.NEXT_PUBLIC_DEFAULT_COUNTRY_CODE,
  // 跳转多语言网站时使用
  current_country_code: process.env.NEXT_PUBLIC_STORE_VIEW_CODE,
  currency: {
    current_currency_code: process.env.NEXT_PUBLIC_DEFAULT_DISPLAY_CURRENCY_CODE,
    default_display_currency_code: process.env.NEXT_PUBLIC_DEFAULT_DISPLAY_CURRENCY_CODE,
    available_currency_codes: ['AUD', 'GBP', 'CAD', 'USD', 'SGD'],
  },
  customize_dress_url: '/aw-dress-lfd.html',
};

export default StoreConfig;
